import _extends from "@babel/runtime/helpers/esm/extends";
// remove node from tree
export function removeNodeFromTree(treeNode, idToRemove) {
  var _treeNode$children;
  return _extends({}, treeNode, {
    children: (_treeNode$children = treeNode.children) != null && _treeNode$children.length ? treeNode.children.filter(child => child.tenantId !== idToRemove) // remove the child if its id matches the idToRemove
    .map(child => removeNodeFromTree(child, idToRemove)) // recursively apply the function to each child
    : []
  });
}